/**
 * Space visualization catalog for the results page dropdown + auto-cycle.
 *
 * These are the 8 visible options from the legacy HTML <select>. The hidden
 * (`d-none`) entries from the old markup — garage2, garage5, garage7, garage8 —
 * are intentionally excluded from both the dropdown and the cycle rotation.
 *
 * Note: `laundryroom` was renamed from `laundryroom_interior` earlier; the
 * PHP endpoint, image folder, and dropdown all use the short name.
 *
 * Carries i18n keys, not display text. This is a plain data module consumed by
 * SpaceSelector, which is a component and translates at render — that ordering
 * matters here because the selector measures its widest label to fix the button
 * width, and the measurement has to see the strings in the active language.
 */

export type SpaceGroup = 'garage' | 'interior';

export interface SpaceOption {
  id: string;
  /** i18n key for the option's display name. */
  labelKey: string;
  group: SpaceGroup;
}

export const SPACE_OPTIONS: SpaceOption[] = [
  { id: 'garage',      labelKey: 'results:spaces.garage',      group: 'garage' },
  { id: 'garage3',     labelKey: 'results:spaces.garage3',     group: 'garage' },
  { id: 'garage4',     labelKey: 'results:spaces.garage4',     group: 'garage' },
  { id: 'garage6',     labelKey: 'results:spaces.garage6',     group: 'garage' },
  { id: 'livingspace', labelKey: 'results:spaces.livingspace', group: 'interior' },
  { id: 'basement',    labelKey: 'results:spaces.basement',    group: 'interior' },
  { id: 'bathroom',    labelKey: 'results:spaces.bathroom',    group: 'interior' },
  { id: 'laundryroom', labelKey: 'results:spaces.laundryroom', group: 'interior' },
  { id: 'generic',     labelKey: 'results:spaces.generic',     group: 'interior' },
];

/** i18n key for a group's heading in the dropdown. */
export const SPACE_GROUP_LABEL_KEYS: Record<SpaceGroup, string> = {
  garage: 'results:spaces.groups.garage',
  interior: 'results:spaces.groups.interior',
};
